module.exports = __webpack_public_path__ + "img/4_20.5c984487.png";